import React from "react";
import { styled } from "../stitches.config";
import { ButtonForwardRef } from "./Button";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import Icon, { IconType } from "../components/Icon";
import { remToPixels } from "../ui/Minimap";
export interface MenuProps extends DropdownMenu.DropdownMenuOwnProps {
  label?: React.ReactChild;
  color?: string;
  chevron?: boolean;
  disabled?: boolean;
  icon?: IconType;
  ariaLabel?: string;
}

export function Menu({
  children,
  label,
  chevron,
  disabled,
  icon,
  ariaLabel,
  color,
  ...props
}: React.PropsWithChildren<MenuProps>) {
  return (
    <>
      <DropdownMenu.Root {...props}>
        <DropdownMenu.Trigger
          as={ButtonForwardRef}
          icon={icon}
          aria-label={ariaLabel}
          title={ariaLabel}
          color={color}
          disabled={disabled}
        >
          {label}
          {chevron && <StyledChevron />}
        </DropdownMenu.Trigger>
        <MenuContent
          disableOutsidePointerEvents={false}
          disableOutsideScroll={false}
          sideOffset={remToPixels(0.75)}
        >
          {children}
        </MenuContent>
      </DropdownMenu.Root>
    </>
  );
}

export const menuContentStyle = {
  padding: "$1",
  borderRadius: "$2",
  border: "1px solid white",
  background: "$menuBeige",
  boxShadow: "$cursor",
  cursor: "default",
};

export const MenuContent = styled(DropdownMenu.Content, menuContentStyle);

export const menuItemStyle = {
  display: "grid",
  border: "none",
  background: "transparent",
  padding: "$2",
  minWidth: 200,
  fontSize: "inherit",
  cursor: "pointer",
  borderRadius: "$1",
  lineHeight: "$4",
  alignItems: "center",
  gridGap: "$2",
  gridAutoFlow: "column",
  justifyContent: "start",
  width: "100%",
  textDecoration: "none",
  "&:visited": {
    color: "inherit",
  },

  "&:hover": {
    background: "$transparentBlack05",
  },

  "&:active": {
    background: "$transparentBlack10",
  },

  "&:focus": {
    background: "$transparentBlack05",
  },

  "&:focus-visible": {
    outline: "none",
  },

  variants: {
    hover: {
      true: {
        background: "$transparentBlack05",
      },
    },
  },
};

export const MenuItem = styled(DropdownMenu.Item, menuItemStyle);

export const MenuLabel = styled(DropdownMenu.Label, {
  color: "$menuTitleGray",
  fontWeight: "$medium",
  padding: "$2",
  fontSize: "$3",
});

export const MenuSeparator = styled(DropdownMenu.Separator, {
  height: 1,
  background: "$transparentBlack05",
  margin: "$1",
});

const StyledChevron = styled(() => <Icon icon="Chevron" />, {
  marginLeft: "$1",
  color: "$transparentBlack25",
});

export const ListMenu = styled("ul", menuContentStyle);
export const ListMenuItem = styled("li", menuItemStyle);
export const ListMenuIconItem = styled("li", {
  ...menuItemStyle,
  padding: "4px $2",
});
